import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";
import { Compare } from "../common/slider";
import { useState } from "react";

function Offer3UslugaGlebogryzarki() {
  const [activeTransform, setActiveTransform] = useState(1);

  const handleChooseTransform = (index: number) => {
    setActiveTransform(index);
  };
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/glebogryzarka-Large.jpeg"
          alt="Glebogryzarka w działaniu - usługa glebogryzarki - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Usługi glebogryzarką separacyjną pod trawnik Gdańsk, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Maszynowe spulchnianie gleby i zakopywanie kamieni na działce
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Przygotowanie twardej lub zniszczonej po budowie ziemi pod nowy trawnik wymaga zastosowania glebogryzarki separacyjnej. Maszyna ta w jednym przejeździe mieli grudki ziemi, zakopuje kamienie pod spód i przesiewa idealnie miękką glebę na wierzch. Świadczymy usługi glebogryzarką na terenie Gdańska, Gdyni, Wejherowa, Kartuz i Kaszub jako wstęp do <a href="/zakladanie-ogrodu/trawa-z-rolki" className="underline hover:opacity-80">zakładania trawników</a>.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Usługi glebogryzarką
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co to jest glebogryzarka?
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Jak działa glebogryzarka?
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Do czego służy glebogryzarka?
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co daje glebogryzarka?
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Dlaczego warto skorzystać z usług glebogryzarki?
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Glebogryzarka do zakładania ogrodu
            </a>
            <a
              href="#8"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie wynająć glebogryzarkę?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Usługi glebogryzarką</h2>
          <p>
            Jako substytut wideł i szpadla, glebogryzarka pozwala na
            efektywniejsze działanie w zakresie przekopywania gleby. Nasza firma
            oferuje usługi za pomocą glebogryzarki wysokiej jakości,
            kompatybilnej z kompaktowym ciągnikiem John Deere 1026R. Usługa
            glebogryzarką jest bardzo wygodna i szybka, zarówno dla małych, jak
            i dużych powierzchni. Wypełnij formularz, a otrzymasz darmową wycenę
            swojego projektu!
          </p>

          <h3 id="2">Co to jest glebogryzarka?</h3>
          <p>
            Z perspektywy językowej, glebogryzarka to urządzenie, które „gryzie”
            glebę. Podłącza się ją do ciągnika, który jest źródłem napędu noży.
            Zębatki są osadzone łukowo lub hakowato i są odpowiedzialne za
            „gryzienie” ziemi. Dzięki możliwości ustawiania zakresu ruchu noży
            możemy dostosować sposób spulchniania ziemi do naszych potrzeb.
            Ogromną funkcjonalnością glebogryzarki jest możliwość pozostawienia
            ziemi praktycznie bez grudek.
          </p>

          <h3 id="3">Jak działa glebogryzarka?</h3>
          <p>
            Noże glebogryzarki, obracając się, wbijają się w glebę, a głębokość
            pracy noży wynosi maksymalnie 20 cm, lecz może być dostosowywana do
            potrzeb i warunków pracy. Dzięki glebogryzarce powierzchnia ziemi
            jest wyrównana, a gleba spulchniona i pozbawiona kamieni.
          </p>

          <h3 id="4">Do czego służy glebogryzarka?</h3>
          <p>
            Glebogryzarka, przede wszystkim, ma poprawiać jakość oraz
            napowietrzenie gleby. Poprzez ruchy noży, glebogryzarka mechanicznie
            narusza ziemię, czyni ją bardziej spulchnioną oraz dodatkowo
            eliminuje z niej chwasty, a także wpuszcza tlen pomiędzy jej
            warstwy. Oferowana przez nas glebogryzarka ciągnikowa sprawdzi się
            zarówno przy większych powierzchniowo obszarach, jak i w
            przydomowych ogródkach czy troskliwie pielęgnowanych trawnikach.
          </p>

          <h3 id="5">Co daje glebogryzarka?</h3>
          <p>
            Glebogryzarka w trakcie spulchniania ziemi wyrównuje gospodarkę
            wodno-powietrzną gleby. Struktura gleby po wykonaniu usługi
            glebogryzarką korzystnie wpływa na rozwój warzyw, owoców czy roślin.
            Mają wtedy powiększone miejsce do rozwoju oraz lepiej przyswajają
            składniki pokarmowe.
          </p>

          <h3 id="6">Dlaczego warto skorzystać z usług glebogryzarki?</h3>
          <p>
            Na to pytanie twierdząca odpowiedź powinien dać każdy, kto jest
            zainteresowany pięknym trawnikiem lub poprawą jakości gleby przed
            sadzeniem czy sianiem trawy. Glebogryzarka świetnie spełni swoją
            funkcję w sadach, na łąkach, pastwiskach, a także w ogrodach. Oprócz
            usuwania chwastów pozwoli wykonać wszystkie czynności związane z
            uprawą gleby, dużo efektywniej niż tradycyjnymi metodami – za pomocą
            szpadla i wideł.
          </p>
          <p>
            Oprócz mroźnej zimy, gdy ziemia jest skuta lodem, czy upalnego lata,
            gdy ziemia jest tak wysuszona, że aż twarda, w każdej innej sytuacji
            można używać glebogryzarki przez cały rok. Akcesoryjne elementy
            pozwalają na rozsypywanie torfu lub kompostu podczas pracy
            glebogryzarki.
          </p>

          <h3 id="7">Glebogryzarka do zakładania ogrodu</h3>
          <p>
            Jeśli mamy w planach założyć swój własny, wymarzony ogród, to usługa
            glebogryzarką powinna być pierwszą rzeczą, jaką wykonamy. Dlaczego?
            Bo zakładanie ogrodu, to przede wszystkim trawa, a żeby uzyskać
            idealną trawę, trzeba przygotować ziemię. Wyrównanie, oczyszczenie z
            kamieni, korzeni czy śmieci oraz pozbycie się chwastów, to idealne
            zadanie dla glebogryzarki. Jeśli następnie zdecydujemy się na
            zakładanie trawy z rolki czy sianie trawy, to będziemy mieli
            bezbłędnie przygotowaną glebę.
          </p>

          <h3 id="8">Gdzie wynająć glebogryzarkę?</h3>
          <p>
            Nasza firma świadczy usługi za pomocą glebogryzarki w Gdańsku i
            całym Trójmieście oraz w Szczecinie i okolicach. Bez problemu
            dotrzemy w każdą część województwa pomorskiego czy kraju. Posiadamy
            zarówno glebogryzarkę ciągnikową, jak i separacyjną. Dobieramy
            sprzęt indywidualnie do każdego projektu i każdej działki. Naszym
            drogowskazem jest zadowolenie klienta. Wypełnij formularz, zadzwoń
            lub napisz do nas maila – otrzymasz darmową wycenę!
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="px-6 pb-6 lg:px-24 lg:pb-12 flex flex-col gap-6">
        <div className="w-full bg-gray-100 rounded-xl p-6 flex flex-col gap-6">
          <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between">
            <div className="flex flex-col items-start justify-start gap-2">
              <h2 className="uppercase color-yellow text-xl">Transformacje</h2>
              <h3 className="text-3xl lg:text-5xl color-green">
                Zobacz jak odmieniamy{" "}
                <span className="color-yellow">ogrody</span>
              </h3>
            </div>
            <a href="/kontakt">
              <button className="button-green">Bezpłatna wycena</button>
            </a>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div
              id="chooseTransform1"
              onClick={() => handleChooseTransform(1)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[350px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/glebo-1-po.jpg"
                alt="Usługa glebogryzarki - realizacja Drzewus nr 1 - widok po"
              />
            </div>
            <div
              id="chooseTransform2"
              onClick={() => handleChooseTransform(2)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[350px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/glebo-2-po.jpg"
                alt="Usługa glebogryzarki - realizacja Drzewus nr 2 - widok po"
              />
            </div>
          </div>
          <div className="">
            <div
              className={`w-full ${activeTransform === 1 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/gebo-1-przed.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/glebo-1-po.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 2 ? "block" : "hidden"}`}
              id="transform2"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/glebo-2-przed.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2025/01/glebo-2-po.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer3UslugaGlebogryzarki;
